<template>
  <NuxtLayout name="loyalty">
    <HeroHeader :title-visible="false" class="loyaltyDashboard__Header" stacked-elements>
      <div class="container">
        <client-only>
          <div v-if="loyaltyData" class="loyaltyDashboard__HeaderInner">
            <div class="loyaltyDasboard__HeaderLeft">
              <i18n-t tag="div" keypath="pointsPlural" scope="global">
                <template #count>
                  <span>{{ loyaltyData.cumulative_points || 0 }}</span>
                </template>
              </i18n-t>
              <div>{{ $t('level') }} <span v-if="loyaltyData.membership_type">{{ loyaltyData.membership_type }}</span></div>
            </div>
  
            <div class="loyaltyDashboard__HeaderRight">
              <div class="loyaltyDashboard__Card">
                <NuxtImg format="webp" src="/resources/images/loyaltycard-logo.png" width="300" height="56" />
                <p>
                  {{ $t('pointsPage.cardNumber') }}
                  <span>{{ loyaltyData.card_number }}</span>
                </p>
              </div>
            </div>
          </div>
        </client-only>
      </div>
    </HeroHeader>

    <div class="loyaltyDashboard">
      <h1 v-text="page.title" />
      <CMSField v-if="page?.content" :data="page.content" />
    </div>

    <InterestsModal />
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess',     
  })

  const props = defineProps({
    page: {
      type: Object
    }
  });

  const { user: data } = useAuth('aminess');

  const loyaltyData = computed(() => data?.value?.loyalty);

  useHead({
    htmlAttrs: {
      class: 'absoluteHeader transparentHeader',
    },
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_loyaltyDashboard.scss');
</style>